module.exports = __webpack_public_path__ + "img/ava-5.89545abd.png";